import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ViewDocsComponent } from './view-docs.component';
import { AttachFileModule } from '../attach-file/attach-file.module';

@NgModule({
  declarations: [
    ViewDocsComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    AttachFileModule,
  ]
})
export class ViewDocsModule { }